export default __webpack_public_path__ + "b03fbfd85afa32ba6674135b45a03999.webp";